module.exports = __webpack_public_path__ + "img/SMSC82904-min.066f6921.png";